const burgerBtn = document.querySelector(".header__icon--summary.burgerBtn");
const closeBtn = document.querySelector(".drawerCloseBtn");
const drawerContainer = document.querySelector(
  "#Details-menu-drawer-container"
);
const headerSection = document.querySelector(".section-header");

burgerBtn.addEventListener("click", () => {
  drawerContainer.classList.add("drawerOpen");
  document.body.classList.add("noscroll");
  headerSection.classList.add("scrolled-past-header");
});

closeBtn.addEventListener("click", () => {
  drawerContainer.classList.remove("drawerOpen");
  document.body.classList.remove("noscroll");
  document.body.classList.remove("overflow-hidden-tablet");
});

headerSection.addEventListener("click", () => {
  headerSection.classList.add("scrolled-past-header");
});
